import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers/';

const finalCreateStore = compose(
  applyMiddleware(thunk),
  window.devToolsExtension ? window.devToolsExtension() : f => f
);

export default function configureStore(initialState = {}) {
  return createStore(rootReducer, initialState, finalCreateStore);
}



// WEBPACK FOOTER //
// ./src/store.js